var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((10),function(x){return _c('div',{key:x,staticClass:"barcode text-center"},[_c('h6',{staticClass:"title text-center"},[_vm._v("Bar Code")]),_c('img',{attrs:{"src":"https://i.ibb.co/jLKHx8c/12000.jpg","alt":""}}),_c('h6',{staticClass:"number text-center"},[_vm._v("21121251521")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }